import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/styles/custom.scss';

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  const userNoInStore = !store.state.user;
  const userNoInCookie = !store.$cookie.get('account');
  const needLogin = to.meta.login;
  const notToLogin = to.name !== 'LogIn';
  if (notToLogin && needLogin && userNoInStore && userNoInCookie) {
    next({ name: 'LogIn' });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
